// CANONICAL COPY (GH #7115). src/constants/obligations/obl-vendor-contracts.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-vendor-contracts',
  title: 'Review vendor contract security requirements',
  description:
    'Verify that all vendor agreements include appropriate information security requirements and that contract expiry dates are tracked.',
  category: 'vendors',
  scfIds: ['SCF-VDR-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'vendor-contracts-tracked',
      description: 'All vendors have contract end dates tracked',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'vendors', label: 'Review Vendors' }],
};
